import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { IoMdRefresh, IoMdCheckmarkCircle, IoMdCloseCircle } from 'react-icons/io';

const generateCaptcha = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let captcha = '';
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

const CaptchaModal = ({ onCaptchaSuccess }) => {
  const [captchaText, setCaptchaText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [error, setError] = useState('');
  const bypasspass = localStorage.getItem('bypassVpn');

  useEffect(() => {
    setCaptchaText(generateCaptcha());
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userInput === captchaText || bypasspass === true) {
      onCaptchaSuccess();
    } else {
      setError('Incorrect captcha. Please try again.');
      setCaptchaText(generateCaptcha()); // Regenerate captcha on failure
      setUserInput(''); // Clear input
    }
  };

  const refreshCaptcha = () => {
    setCaptchaText(generateCaptcha());
    setUserInput('');
    setError('');
  };

  return createPortal(
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 w-screen h-screen p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Security Verification</h2>
        <p className="text-gray-700 mb-6">
          To ensure you are not a bot, please complete the captcha.
        </p>

        <div className="mb-6 flex items-center justify-center space-x-4">
          <div className="bg-gray-200 text-gray-800 font-bold text-3xl px-6 py-3 rounded-md tracking-wider select-none border-2 border-gray-300">
            {captchaText}
          </div>
          <button
            onClick={refreshCaptcha}
            className="p-3 bg-gray-800 hover:bg-gray-900 text-white rounded-md transition duration-300 ease-in-out"
            title="Refresh Captcha"
          >
            <IoMdRefresh size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter captcha"
            className="w-full p-3 mb-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
            value={userInput}
            onChange={(e) => {
              setUserInput(e.target.value);
              setError(''); // Clear error on typing
            }}
            autoComplete="off"
            autoCapitalize="off"
            spellCheck="false"
          />
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <button
            type="submit"
            className="w-full bg-gray-800 hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded-md transition duration-300 ease-in-out flex items-center justify-center"
          >
            <IoMdCheckmarkCircle className="mr-2" /> Verify
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default CaptchaModal;
